import React, { useState, useRef } from 'react';

interface Product {
  name: string;
  category: string;
  description: string;
  price?: string;
  image: string;
}

const NewProducts: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const products: Product[] = [
    {
      name: 'GPS Garmin 1050',
      category: 'GPS',
      description: 'Le nouveau compteur de vélo Edge 1050 fournit un suivi adaptatif et dynamique des performances ainsi que des données pour progresser.',
      price: '799€',
      image: '/produits/Capture d\'écran 2026-01-14 212839.png'
    },
    {
      name: 'VELODROM RaceDay x Meraki Colab Limited Edition Maillot',
      category: 'Maillot',
      description: 'Le maillot de course VELODROM RaceDay x Meraki Colab Limited Edition est un véritable chef-d\'œuvre de la conception textile.',
      price: '199€',
      image: '/produits/Capture d\'écran 2026-01-14 212901.png'
    },
    {
      name: 'Oakley Radarlock',
      category: 'Lunettes',
      description: 'Oakley Radarlock sont des lunettes de soleil haut de gamme conçues pour les cyclistes. Elles offrent une protection solaire optimale et une visibilité exceptionnelle.',
      price: '249€',
      image: '/produits/Capture d\'écran 2026-01-14 212919.png'
    },
    {
      name: 'Casque MERAKI',
      category: 'Casque',
      description: 'Casque MERAKI sont des casques de vélo haut de gamme conçus pour les cyclistes. Elles offrent une protection optimale et une visibilité exceptionnelle.',
      price: '149€',
      image: '/produits/Capture d\'écran 2026-01-14 213127.png'
    },
    {
      name: 'Casette Shimano Dura-Ace',
      category: 'Casette',
      description: 'Casette Shimano Dura-Ace sont des casettes de vélo haut de gamme conçues pour les cyclistes. Elles offrent une performance optimale et une durabilité exceptionnelle.',
      price: '289€',
      image: '/produits/Image (9).png'
    },
    {
      name: 'Cintre Aéro Carbone',
      category: 'Cintre',
      description: 'Cintre Aéro Carbone sont des cintres de vélo haut de gamme conçus pour les cyclistes. Elles offrent une performance optimale et une durabilité exceptionnelle.',
      price: '329€',
      image: '/produits/Image (10).png'
    },
    {
      name: 'Roues Corima ',
      category: 'Roues',
      description: 'Roues Corima sont des roues de vélo haut de gamme conçues pour les cyclistes. Elles offrent une performance optimale et une durabilité exceptionnelle.',
      price: '2499€',
      image: '/produits/Image (11).png'
    }
  ];

  const itemsPerView = 3;
  const maxIndex = Math.max(0, products.length - itemsPerView);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };

  return (
    <section className="py-16 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-12 flex items-center justify-between">
          <h2 className="text-4xl md:text-5xl font-bold text-black">
            Nouveauté / Promotions
          </h2>
          
          {/* Navigation Buttons - Desktop */}
          <div className="hidden lg:flex items-center space-x-4">
            <button
              onClick={prevSlide}
              className="p-3 rounded-full bg-white shadow-lg hover:bg-gray-100 transition-colors duration-300"
              aria-label="Produit précédent"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <button
              onClick={nextSlide}
              className="p-3 rounded-full bg-white shadow-lg hover:bg-gray-100 transition-colors duration-300"
              aria-label="Produit suivant"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>

        {/* Carousel Container */}
        <div className="relative">
          {/* Products Carousel */}
          <div className="overflow-hidden">
            <div
              ref={scrollContainerRef}
              className="flex transition-transform duration-500 ease-in-out"
              style={{
                transform: `translateX(-${currentIndex * (100 / itemsPerView)}%)`
              }}
            >
              {products.map((product, index) => (
                <div
                  key={index}
                  className="w-full md:w-1/2 lg:w-1/3 flex-shrink-0 px-4"
                >
                  <div className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 h-full">
                    {/* Product Image */}
                    <div className="aspect-square bg-gray-100 overflow-hidden relative">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-full h-full object-contain hover:scale-105 transition-transform duration-300"
                      />
                      {product.price && (
                        <div className="absolute top-4 right-4 bg-black text-white px-4 py-2 rounded-full font-bold">
                          {product.price}
                        </div>
                      )}
                    </div>
                    
                    {/* Product Info */}
                    <div className="p-6">
                      <p className="text-sm text-gray-500 uppercase tracking-wide mb-2">
                        {product.category}
                      </p>
                      <h3 className="text-xl font-bold text-black mb-3">
                        {product.name}
                      </h3>
                      <p className="text-gray-600 text-sm leading-relaxed mb-4">
                        {product.description}
                      </p>
                      <button className="w-full bg-black text-white py-3 rounded-lg hover:bg-gray-800 transition-colors duration-300 font-medium">
                        Voir le produit
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Buttons - Mobile/Tablet */}
          <div className="flex lg:hidden items-center justify-center space-x-4 mt-8">
            <button
              onClick={prevSlide}
              className="p-3 rounded-full bg-white shadow-lg hover:bg-gray-100 transition-colors duration-300"
              aria-label="Produit précédent"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <span className="text-sm text-gray-600">
              {currentIndex + 1} / {products.length - itemsPerView + 1}
            </span>
            <button
              onClick={nextSlide}
              className="p-3 rounded-full bg-white shadow-lg hover:bg-gray-100 transition-colors duration-300"
              aria-label="Produit suivant"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>

          {/* Progress Indicator */}
          <div className="mt-6 flex justify-center space-x-2">
            {Array.from({ length: maxIndex + 1 }).map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`h-2 rounded-full transition-all duration-300 ${
                  index === currentIndex ? 'w-8 bg-black' : 'w-2 bg-gray-300'
                }`}
                aria-label={`Aller au groupe ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewProducts;

